/*global DocViewerEvents */

var AnnotationUtilities = require('@amzn/aws-workdocs-web-client-common').AnnotationUtilities;
(function(angular, _) {
    'use strict';

    angular.module('GorillaBoy.DocumentViewer')
        .controller('DocumentRightPanelController', [
            '$scope',
            '$filter',
            '$log',
            '$q',
            'AppConstants',
            'AnnotationService',
            'DocumentService',
            'authenticatedUser',
            'ClientMetricsService',
            'DocumentStateService',
            'MetricEvents',
            'DocumentUtilities',
            '$rootScope',
            '$timeout',
            '$translate',
            'MessageManager',
            'MessageProvider',
            'SignalProvider',
            '$routeParams',
            'FeedbackService',
            'FeedbackLocalStorageService',            
            DocumentRightPanelController
        ]);
    function DocumentRightPanelController($scope, $filter, $log, $q, AppConstants, AnnotationService, DocumentService, authenticatedUser, ClientMetricsService,
        DocumentStateService, MetricEvents, DocumentUtilities, $rootScope, $timeout, $translate,
        MessageManager, MessageProvider, SignalProvider, $routeParams,
        FeedbackService, FeedbackLocalStorageService) {

        var globalRoles = AppConstants.GlobalRoles;
        /**
         * PLEASE NOTE THAT THIS CONTROLLER GETS DESTROYED AND RECREATED WHEN TOGGLING THE RIGHT PANEL
         */
        var DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION1 = "UnauthorizedResourceAccessException";
        var DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION2 = "DocumentLockedForCommentsException";
        var FEEDBACK_VISIBILITY = AppConstants.FEEDBACK_VISIBILITY;
        var feedbackTypes = AppConstants.FeedbackTypes,
            rightTabTypes = AppConstants.RightTabTypes;

        $scope.documentStateService = DocumentStateService;
        var documentViewerBridge = $scope.documentState.documentViewerBridge;

        if ($routeParams.showFeedback) {
            //If the currentUserRoles is not ready, wait for it to load
            if (!DocumentStateService.currentUserRoles) {
                var permissonsLoadedWatchDeRegFn = $scope.$watch('permissonsLoaded', function(newVal) {
                    if (newVal) {
                        permissonsLoadedWatchDeRegFn();
                        showFeedbackPanelBasedOnRouteParam();
                    }
                });
            } else {
                showFeedbackPanelBasedOnRouteParam();
            }
        }

        function showFeedbackPanelBasedOnRouteParam() {
            if ($scope.showFeedbackButton()) {
                $scope.toggleOrShowRightPanelWithTab(rightTabTypes.FEEDBACK_TAB);
            }
        }


        //New annotations actions
        documentViewerBridge.on(DocViewerEvents.TEXT_SELECTED_IN_PAGE, onTextSelectionInPage);
        documentViewerBridge.on(DocViewerEvents.RECTANGLE_DRAWN_IN_PAGE, onRectangleSelectionInPage);

        documentViewerBridge.on(DocViewerEvents.TEXT_SELECTION_STARTED_IN_PAGE, onTextSelectionStartedInPage);
        documentViewerBridge.on(DocViewerEvents.RECTANGLE_SELECTION_STARTED_IN_PAGE, onRectangleSelectionStartedInPage);


        documentViewerBridge.on(DocViewerEvents.CLICKED_OUTSIDE_IN_PAGE, onClickedOutsideInPage);

        //Existing annotation actions
        documentViewerBridge.on(DocViewerEvents.ANNOTATION_SELECTED_IN_PAGE, onAnnotationSelectedInPage);
        documentViewerBridge.on(DocViewerEvents.ANNOTATION_UNSELECTED_IN_PAGE, onAnnotationUnselectedInPage);

        //UX actions emitted from bottom frame
        documentViewerBridge.on(DocViewerEvents.PRESENTATION_MODE_CHANGED, onPresentationModeChanged);
        documentViewerBridge.on(DocViewerEvents.SCROLLED_TO_PAGE, onScrolledToPage);

        //Fired when version switch happens
        $scope.documentState.documentViewerBridge.on(DocViewerEvents.RELOAD_ANNOTATIONS, onReloadAnnotations);

        function onReloadAnnotations() {
            $timeout(function() {
                if ($scope.sidebar.tabName === rightTabTypes.FEEDBACK_TAB) {
                    $scope.reselectFeedback();
                }
            });
        }

        function onPresentationModeChanged(action) {
            var enterExitFlag = action.payload;
            if (enterExitFlag) {
                documentViewerBridge.hideAnnotations();
            } else if ($scope.sidebar.tabName === AppConstants.RightTabTypes.FEEDBACK_TAB) {
                documentViewerBridge.showAnnotations();
            }
        }

        $scope.$on("$destroy", function() {
            documentViewerBridge.hideAnnotations();

            //New annotations actions
            documentViewerBridge.off(DocViewerEvents.TEXT_SELECTION_STARTED_IN_PAGE, onTextSelectionStartedInPage);
            documentViewerBridge.off(DocViewerEvents.RECTANGLE_SELECTION_STARTED_IN_PAGE, onRectangleSelectionStartedInPage);
            documentViewerBridge.off(DocViewerEvents.TEXT_SELECTED_IN_PAGE, onTextSelectionInPage);
            documentViewerBridge.off(DocViewerEvents.RECTANGLE_DRAWN_IN_PAGE, onRectangleSelectionInPage);
            documentViewerBridge.off(DocViewerEvents.CLICKED_OUTSIDE_IN_PAGE, onClickedOutsideInPage);

            //Existing annotation actions
            documentViewerBridge.off(DocViewerEvents.ANNOTATION_SELECTED_IN_PAGE, onAnnotationSelectedInPage);
            documentViewerBridge.off(DocViewerEvents.ANNOTATION_UNSELECTED_IN_PAGE, onAnnotationUnselectedInPage);

            //UX actions emitted from bottom frame
            documentViewerBridge.off(DocViewerEvents.PRESENTATION_MODE_CHANGED, onPresentationModeChanged);
            documentViewerBridge.off(DocViewerEvents.SCROLLED_TO_PAGE, onScrolledToPage);
            documentViewerBridge.off(DocViewerEvents.RELOAD_ANNOTATIONS, onReloadAnnotations);
        });

        $scope.$on(SignalProvider.FeedbackDrawn.FeedbackPanelScrolled, function() {
            var selectedFeedback = DocumentStateService.feedback.selectedFeedback;
            //It is possible that sidebar scrolls when user starts region selection, ignore that case!
            if (!selectedFeedback || $scope.documentState.ignoreFeedbackScrolling || textRegionSelectionStarted) {
                return;
            }
            var AnnotationId = selectedFeedback.AnnotationId,
                pageNumber = selectedFeedback.StartPageNumber + 1;
            $scope.getAnnotationClientRect(AnnotationId, false).then(function(boundingClientRect) {
                if (selectedFeedback.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_INPUT) {
                    if (selectedFeedback.AnnotationType === AppConstants.ANNOTATION_TYPE.HIGHLIGHT) {
                        documentViewerBridge.renderArrowForTextSelection(pageNumber, {
                            top: FeedbackService.getArrowTopPosition(boundingClientRect)
                        });
                    } else {
                        documentViewerBridge.renderArrowForRectangleSelection(pageNumber, {
                            top: FeedbackService.getArrowTopPosition(boundingClientRect)
                        });
                    }
                } else {
                    documentViewerBridge.annotationSelected(pageNumber, selectedFeedback, {
                        top: FeedbackService.getArrowTopPosition(boundingClientRect)
                    });
                }
            });
        });

        function onAnnotationUnselectedInPage(action) {
            $scope.$evalAsync(function() {
                $scope.deselectFeedback();
            });
        }

        function onAnnotationSelectedInPage(action) {
            var AnnotationId = action.payload.AnnotationId;
            var feedbackObj = DocumentUtilities.getAnnotationObjectFromId($scope.documentState.feedbackListMap, AnnotationId);
            if (feedbackObj && feedbackObj.ThreadId !== feedbackObj.AnnotationId) {
                feedbackObj = DocumentUtilities.getAnnotationObjectFromId($scope.documentState.feedbackListMap, feedbackObj.ThreadId);
            }
            if (feedbackObj) {
                $scope.$evalAsync(function() {
                    $scope.selectFeedback(feedbackObj, true);
                });
            }
        }

        function onClickedOutsideInPage(action) {
            $scope.$evalAsync(function() {
                DocumentStateService.feedback.selectedFeedback = null;
                $scope.__cleanupAnyAnnotationInputs();
            });
        }

        function onScrolledToPage(action) {
            action = null;
        }

        var textRegionSelectionStarted = false;
        function onTextOrRegionSelectionStartedInPage(action, AnnotationType) {
            textRegionSelectionStarted = true;
            if ($scope.layout.showRightSidebar && ($scope.sidebar.tabName !== AppConstants.RightTabTypes.FEEDBACK_TAB)) {
                $scope.showRightTab('Feedback');
                $timeout(doTask, 500);
            } else {
                var expandCollapsedState = $scope.documentState.expandCollapsedState[$scope.documentState.activeVersion.VersionId];
                if ($scope.layout.showFilterPanel || (expandCollapsedState && expandCollapsedState.commentsPanelCollapsed)) {
                    $scope.layout.showFilterPanel = false;
                    expandCollapsedState.commentsPanelCollapsed = false;
                    $timeout(doTask);
                } else {
                    doTask();
                }
            }

            function doTask() {
                var payload = action.payload,
                    pageNumber = payload.pageNumber,
                    regions = payload.regions;
                var latencyHandle = ClientMetricsService.startNewLatencyEvent({
                    event: MetricEvents.FEEDBACK_PANEL_EVENTS.RENDER_FEEDBACK_INPUT,
                    documentId: $scope.metadata.Id,
                    versionId: $scope.metadata.VersionMetadata.VersionId
                });
                var feedbackInputRenderLatency = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();
                $scope.__addDraftAnnotationInput(pageNumber, AnnotationType, regions);

                //emitting two metrics for comparison
                setTimeout(function() {
                    feedbackInputRenderLatency.emitMetricWithMethodName('DocumentViewer.RenderFeedbackInput_Next_Tick');
                });
                $scope.registerPostDigestCallback(function() {
                    $scope.$broadcast(SignalProvider.Sidebar.FocusFeedbackInput, {});
                    latencyHandle.stopAndRecordLatency();
                    feedbackInputRenderLatency.emitMetricWithMethodName('DocumentViewer.RenderFeedbackInput');
                });
            }
        }

        var waitForFeedbackInputRenderLimitRetries = 10,
            currentRetry = 0;

        function isValidRegions(regions) {
            if (!regions || !regions.length) {
                return false;
            }
            return regions.every(function(region) {
                return region.BottomRight && region.TopLeft &&
                    region.BottomRight.X !== undefined && region.BottomRight.Y >= 0 &&
                    region.TopLeft.X !== undefined && region.TopLeft.Y >= 0;
            });
        }

        function onTextOrRegionSelectionInPage(action, AnnotationType) {
            textRegionSelectionStarted = false;
            var payload = action.payload,
                pageNumber = payload.pageNumber,
                regions = payload.regions;
            
            // If right panel is not shown, do nothing but preserve the selection because
            // newAnnotationCancel will deselect the selected text making it impossible to copy text
            if (!$scope.layout.showRightSidebar) {
                return;
            }

            if (!isValidRegions(regions)) {
                //If for some reason you get invalid regions object, then cancel that annotation
                $scope.newAnnotationCancel();
                return;
            }

            var selectedFeedback = DocumentStateService.feedback.selectedFeedback;
            if (!selectedFeedback || selectedFeedback.AnnotationStatus !== feedbackTypes.FEEDBACK_TYPE_INPUT) {
                $timeout(function() {
                    if (currentRetry++ > waitForFeedbackInputRenderLimitRetries) {
                        currentRetry = 0;
                        return;
                    }
                    onTextOrRegionSelectionInPage(action, AnnotationType);
                }, 50);
                return;
            }
            $scope.documentState.pendingAnnotation = {
                regions: regions,
                startLine : payload.startLine,
                startWord : payload.startWord,
                endLine : payload.endLine,
                endWord : payload.endWord,
                pageNumber : payload.pageNumber,
                type : AnnotationType
            };
            //Update the regions on the draft feedback (which is selected feedback)
            selectedFeedback.Regions = regions;

            //First the selectedFeedback to NULL so that it does not trigger $digest()
            DocumentStateService.feedback.selectedFeedback = null;
            var latencyHandle = ClientMetricsService.startNewLatencyEvent({
                    event: MetricEvents.FEEDBACK_PANEL_EVENTS.RENDER_FEEDBACK_ARROW_FOR_INPUT,
                    documentId: $scope.metadata.Id,
                    versionId: $scope.metadata.VersionMetadata.VersionId
                });
            var feedbackArrowRenderLatency = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();

            //Let that $digest() first! Otherwise we won't find our "#annotation-ID" element in the DOM
            $timeout(function() {
                $scope.getAnnotationClientRect(selectedFeedback.AnnotationId, true).then(function(boundingClientRect) {
                    DocumentStateService.feedback.selectedFeedback = selectedFeedback;
                    var methodName = AnnotationType === AppConstants.ANNOTATION_TYPE.HIGHLIGHT ? 'renderArrowForTextSelection': 'renderArrowForRectangleSelection';
                    documentViewerBridge[methodName](pageNumber, {
                        top: FeedbackService.getArrowTopPosition(boundingClientRect)
                    });
                    $scope.registerPostDigestCallback(function() {
                        feedbackArrowRenderLatency.emitMetricWithMethodName('DocumentViewer.RenderArrowForFeedbackInput');
                        latencyHandle.stopAndRecordLatency();
                    });
                    setTimeout(function() {
                        feedbackArrowRenderLatency.emitMetricWithMethodName('DocumentViewer.RenderArrowForFeedbackInput_Next_Tick');
                    });
                });
            });
        }

        function onTextSelectionInPage(action) {
            $timeout(onTextOrRegionSelectionInPage, 0, true, action, AppConstants.ANNOTATION_TYPE.HIGHLIGHT);
        }

        function onRectangleSelectionInPage(action) {
            $timeout(onTextOrRegionSelectionInPage,0, true, action, AppConstants.ANNOTATION_TYPE.REGION);
        }

        function onTextSelectionStartedInPage(action) {
            $timeout(onTextOrRegionSelectionStartedInPage, 0, true, action, AppConstants.ANNOTATION_TYPE.HIGHLIGHT);
        }

        function onRectangleSelectionStartedInPage(action) {
            $timeout(onTextOrRegionSelectionStartedInPage,0, true, action, AppConstants.ANNOTATION_TYPE.REGION);
        }

        $scope.preprocessFeedbackText = function(feedbackObj) {
            var text = DocumentUtilities.parseTextAndEmbedMarkdownForEmails(feedbackObj.Text);
            feedbackObj.MarkupText = remarkableMd.render(text);
        };

        $scope.__selectAnnotationById = function(AnnotationId) {
            var feedbackObj = DocumentUtilities.getAnnotationObjectFromId($scope.documentState.feedbackListMap, AnnotationId);
            if (feedbackObj && feedbackObj.ThreadId !== feedbackObj.AnnotationId) {
                feedbackObj = DocumentUtilities.getAnnotationObjectFromId($scope.documentState.feedbackListMap, feedbackObj.ThreadId);
            }
            if (feedbackObj) {
                $scope.selectFeedbackAndVersion(feedbackObj, feedbackObj.VersionId);
            } else {
                $log.debug('Could not find the feedbackObj for the corressponding AnnotationId >' + AnnotationId +  '< passed in the $routeParams');
            }
        };

        $scope.__scrollCommentIntoView = function(feedbackObj) {
            $timeout(function() {
                var el = document.getElementById("overallComment-" + feedbackObj.CommentId) || document.getElementById("overallCommentReply-" + feedbackObj.CommentId);
                if (!el) {
                    return;
                }
                //Sometimes the feedbackObj that's stored in the feedbackListMap and the param are not the same. So get the actual object to mutate
                feedbackObj = DocumentUtilities.getCommentObjectFromId($scope.documentState.feedbackListMap, feedbackObj.CommentId);
                if (!feedbackObj) {
                    //Return if you can't find the feedback object.
                    return;
                }

                var $el = $(el);
                var $scrollWrapper = $el.parents(".scrollWrapper");
                var boundingClientRect = el.getBoundingClientRect();
                var wrapperBoundingClientRect = $scrollWrapper.get(0).getBoundingClientRect();
                if (boundingClientRect.top > $scrollWrapper.height() - $el.height()) {
                    $log.debug("Positioning the comment upwards for the bottom to be visisble");
                    // scroll 40px more to avoid ".drafts-pending-container"
                    $scrollWrapper.scrollTop($scrollWrapper.scrollTop() + (boundingClientRect.bottom - wrapperBoundingClientRect.bottom) + 40);
                } else if ($scope.documentState.selectedPerson && boundingClientRect.top < 140) {
                    //140px is the boundingClientRect().bottom value of the "Showing XYZ Feedback" div.
                    //If this is the first annotation for the page and there's a filtering by user then push the scrollbar up by 200px
                    $scrollWrapper.scrollTop($scrollWrapper.scrollTop() - (wrapperBoundingClientRect.top - boundingClientRect.top) - 200);
                } else if (boundingClientRect.top < 60) {
                    //If this is the first annotation for the page then push the scrollbar up by 100px
                    $scrollWrapper.scrollTop($scrollWrapper.scrollTop() - (wrapperBoundingClientRect.top - boundingClientRect.top) - 100);
                }
                //Only position element using scrollTop, that's the only reliable way. HTMLElement.scrollIntoView() is buggy!
                feedbackObj.InitiallyHidden = false;
            });
        };

        $scope.__checkRouteParamForFeedbackIds = function() {
            if ($scope.documentState.searchParamFeedbackHighlighted) {
                return;
            }
            if ($routeParams.AnnotationId) {
                $scope.documentState.searchParamFeedbackHighlighted = true;
                if ($scope.sidebar.tabName !== rightTabTypes.FEEDBACK_TAB) {
                    $scope.showRightTab(rightTabTypes.FEEDBACK_TAB);
                    $timeout(callSelectAnnotation, 250); //This value should be greater than TAB_CHANGE_DELAY in rightDirective.js
                } else {
                    callSelectAnnotation();
                }
            } else if ($routeParams.CommentId) {
                $scope.documentState.searchParamFeedbackHighlighted = true;
                if ($scope.sidebar.tabName !== rightTabTypes.FEEDBACK_TAB) {
                    $scope.showRightTab(rightTabTypes.FEEDBACK_TAB);
                    $timeout(function() {
                        $scope.__scrollCommentIntoView({CommentId : $routeParams.CommentId});
                    }, 250, false); //This value should be greater than TAB_CHANGE_DELAY in rightDirective.js
                } else {
                    $scope.__scrollCommentIntoView({CommentId : $routeParams.CommentId});
                }
            }

            function callSelectAnnotation() {
                //In the next digest loop you'll find the annotation Node in the DOM
                $timeout($scope.__selectAnnotationById.bind($scope, $routeParams.AnnotationId), 0);
            }
        };

        $scope.$watch('documentState.feedbackLoaded && documentState.pdfDataLoaded', function(newVal, oldVal) {
            if (newVal === oldVal || !newVal) {
                return;
            }
            $scope.__checkRouteParamForFeedbackIds();
        });

        //Very important to add the user to feedbackUserMap, otherwise drawLines() code breaks as it can't get color for a user
        $scope.addUserToFeedbackUserMap(authenticatedUser.getUserInfo() || $scope.user);


        $scope.toggleResolveStatus = function(feedbackObject) {
            var feedbackObjectOld = feedbackObject;
            var isUnresolved = DocumentUtilities.isUnresolved(feedbackObject);
            if (!feedbackObject.ResolutionInfo) {
                feedbackObject.ResolutionInfo = {};
            }
            feedbackObject.ResolutionInfo.ResolutionStatus = isUnresolved ? AppConstants.FEEDBACK_RESOLUTION_STATUS.RESOLVED : AppConstants.FEEDBACK_RESOLUTION_STATUS.UNRESOLVED;
            if (feedbackObject.CommentId) {
                FeedbackService.updateCommentResolution(feedbackObject.DocumentId, feedbackObject.VersionId, feedbackObject.CommentId, isUnresolved)
                .then(onSuccessCallback, restorePreviousStatus);
            } else if (feedbackObject.AnnotationId) {
                FeedbackService.updateAnnotationResolution(feedbackObject.DocumentId, feedbackObject.VersionId,
                    feedbackObject.AnnotationId, isUnresolved)
                .then(onSuccessCallback, restorePreviousStatus);
            }
            function onSuccessCallback() {
                feedbackObject.ResolutionInfo.EventTime = (new Date()).getTime() / 1000;
                if (DocumentStateService.feedback.selectedFeedback === feedbackObject) {
                    $scope.deselectFeedback();
                }
                $scope.applyFeedbackFilters();
            }
            function restorePreviousStatus() {
                MessageManager.addErrorMessage($translate.instant(isUnresolved ? 'RIGHT_NAV.RESOLVE_SAVE_FAILURE' : 'RIGHT_NAV.UNRESOLVE_SAVE_FAILURE'));
                if (feedbackObjectOld.ResolutionInfo) {
                    feedbackObject.ResolutionInfo.ResolutionStatus = feedbackObjectOld.ResolutionInfo.ResolutionStatus;
                }
                if (DocumentStateService.feedback.selectedFeedback === feedbackObject) {
                    $scope.deselectFeedback();
                }
                $scope.applyFeedbackFilters();
            }
        };

        $scope.getResolutionTooltip = function(feedbackObject) {
            //If there was no event time, that means no body resolved/unresolved the feedback. Show no tooltip in that case
            if (!feedbackObject || !feedbackObject.ResolutionInfo || !feedbackObject.ResolutionInfo.EventTime || !feedbackObject.ResolutionInfo.User) {
                return;
            }
            var ResolutionInfo = feedbackObject.ResolutionInfo;
            var msgKey;
            if (ResolutionInfo.UserId === $scope.userInfo.Id) {
                msgKey = ResolutionInfo.ResolutionStatus === AppConstants.FEEDBACK_RESOLUTION_STATUS.RESOLVED ? 'RIGHT_NAV.SELF.RESOLVE_TOOLTIP_TEXT' : 'RIGHT_NAV.SELF.UNRESOLVE_TOOLTIP_TEXT';
            } else {
                msgKey = ResolutionInfo.ResolutionStatus === AppConstants.FEEDBACK_RESOLUTION_STATUS.RESOLVED ? 'RIGHT_NAV.RESOLVE_TOOLTIP_TEXT' : 'RIGHT_NAV.UNRESOLVE_TOOLTIP_TEXT';
            }
            return $translate.instant(msgKey, {
                User : $translate.instant('DOCUMENT_VIEW.VERSION.AUTHOR', {
                    givenName : ResolutionInfo.User.GivenName,
                    surName : ResolutionInfo.User.Surname
                }),
                RelativeTime : moment(new Date(ResolutionInfo.EventTime * 1000)).fromNow()
            });
        };

        $scope.canUpdateResolutionStatus = function (feedbackObject) {
            return DocumentUtilities.isPublished(feedbackObject) && $scope.canResolveOrUnresolveFeedback(feedbackObject) &&
                (DocumentUtilities.isResolved(feedbackObject) || DocumentUtilities.isUnresolved(feedbackObject));
        };

        /**
         * Only the proprietors OR the feedback owner can resolve the feedback.
         *
         */
        $scope.canResolveOrUnresolveFeedback = function(feedbackObject) {
            if (feedbackObject.Contributor.Id === $scope.userInfo.Id) {
                return true;
            }
            //currentUserRoles object may not be initialized yet. Handle that case!
            if (!DocumentStateService.currentUserRoles) {
                return false;
            }
            var isProprietor = DocumentStateService.currentUserRoles.some(function(roleObj) {
                return roleObj.role === globalRoles.OWNER || roleObj.role === globalRoles.COOWNER;
            });
            return isProprietor;
        };


        $scope.cancelDraftAnnotationPublishing = function() {
            $scope.rightPanelView.forceHidingDraftPublishingComponent = true;
        };

        $scope.$watch('documentState.expandCollapsedState', function(newVal, oldVal) {
            var currentVersionStatus;
            if (newVal === oldVal || !DocumentStateService.feedback || !DocumentStateService.feedback.selectedFeedback) {
                return;
            }
            currentVersionStatus = newVal[DocumentStateService.feedback.selectedFeedback.VersionId];
            if (currentVersionStatus && currentVersionStatus.commentsPanelCollapsed) {
                $scope.deselectFeedback();
                $scope.__cleanupAnyAnnotationInputs();
            }
        }, true);

        //When user toggles the right panel, the scope is destroyed.
        $scope.$on('$destroy', function() {
            $scope.deselectFeedback();
            $scope.__cleanupAnyAnnotationInputs();
        });

        $scope.copyHighlightedText = function() {
            var pendingAnnotation = $scope.documentState.pendingAnnotation;
            var linesToCopy = AnnotationUtilities.getLinesInSelection(AnnotationService.annotationIndex, pendingAnnotation.pageNumber, pendingAnnotation.startLine, pendingAnnotation.startWord, pendingAnnotation.endLine, pendingAnnotation.endWord);
            return linesToCopy.join("\r\n");
        };

        $scope.$watch('documentFormData.disableFeedback', function(newVal, oldVal) {
            if (newVal === oldVal || !newVal) {
                return;
            }
            $scope.__cleanupAnyAnnotationInputs();
        });

        $scope.__compareFeedbackSection = function (feedbackSectionA, feedbackSectionB) {
            return feedbackSectionA.marker - feedbackSectionB.marker;
        };



        /**
         * Only if the feedback is PUBLISHED or DELETED, can other users see the feedback.
         */
        $scope.isFeedbackVisibleToOthers = function(feedbackObj) {
            var FeedbackTypes = AppConstants.FeedbackTypes,
                status;
            if (DocumentUtilities.isComment(feedbackObj)) {
                status = feedbackObj.CommentStatus;
            } else if (DocumentUtilities.isAnnotation(feedbackObj)) {
                status = feedbackObj.AnnotationStatus;
            }
            return status && status === FeedbackTypes.FEEDBACK_TYPE_PUBLISHED || status === FeedbackTypes.FEEDBACK_TYPE_DELETED;
        };

        $scope.submitOverallComment = function(feedbackText, extraData) {
            var newFeedbackObj = {
                DocumentId : $scope.metadata.Id,
                VersionId : DocumentStateService.activeVersionId
            };
            $scope.__publishOverallComment(newFeedbackObj, feedbackText, extraData.notifyCollaborators && !extraData.isPrivate, extraData.isPrivate).then($scope.__scrollCommentIntoView.bind($scope));
         };

         $scope.submitOverallCommentReply = function(feedbackText, extraData) {
            var feedbackObj = extraData.feedbackObject;
            if (feedbackObj) {
                $scope.__publishOverallComment(feedbackObj, feedbackText, extraData.notifyCollaborators && !extraData.isPrivate, extraData.isPrivate);
            }
            if (feedbackObj) {
                feedbackObj.inReplyMode = false;
            }
        };

        $scope.filterReplies = function(Replies, expanded) {
            if (!Replies || !Replies.length || expanded || Replies.length <= 4) {
                return Replies;
            }
            return Replies.slice(Replies.length - 4);
        };

        $scope.cancelOverallComment = function() {
            $scope.rightPanelView.forceShowingOverallComment = false;
        };

        //Always show only one feedback in reply mode
        $scope.__lastFeedbackInReplyMode = null;
        $scope.__lastFeedbackInEditMode = null;
        $scope.replyToFeedback = function(feedbackObject) {
            $scope.__cleanupAnyAnnotationInputs();
            $scope.rightPanelView.forceShowingOverallComment = false;
            $scope.rightPanelView.forceHidingDraftPublishingComponent = true;
            feedbackObject.inReplyMode = true;
            $scope.__lastFeedbackInReplyMode = feedbackObject;
            if (DocumentStateService.feedback.selectedFeedback !== feedbackObject) {
                $scope.deselectFeedback();
            }
        };
        $scope.replyToReplyFeedback = function(replyFeedbackObject) {
            $scope.__cleanupAnyAnnotationInputs();

            $scope.rightPanelView.forceShowingOverallComment = false;
            $scope.rightPanelView.forceHidingDraftPublishingComponent = true;

            replyFeedbackObject.inReplyMode = true;
            $scope.__lastFeedbackInReplyMode = replyFeedbackObject;
            var threadFeedbackObj = $scope.__getFeedbackObjectForThread(replyFeedbackObject);
            if (DocumentStateService.feedback.selectedFeedback !== threadFeedbackObj) {
                $scope.deselectFeedback();
            }
        };

        $scope.editAnnotation = function(feedbackObject) {
            $scope.rightPanelView.forceShowingOverallComment = false;
            $scope.rightPanelView.forceHidingDraftPublishingComponent = true;
            $scope.__cleanupAnyAnnotationInputs();
            feedbackObject.inEditMode = true;
            $scope.__lastFeedbackInEditMode = feedbackObject;
        };

        /**
         * Deletes the comment from the view model. If the feedback is a top level comment of a thread, it will be
         * a) Deleted completely if there are no child replies. OR
         * b) Marked as "DELETED" if there are child replies.
         *
         * @param feedbackObj This can be the top level comment or a child reply comment object
         */
        $scope.removeCommentFromViewModel = function(feedbackObj) {
            var versionId = feedbackObj.VersionId;
            var feedbackSections = $scope.documentState.feedbackListMap[versionId];
            feedbackSections.some(function(feedbackSection){
                var feedbackObjRemovalIdx = -1,
                    containsReplies = false;
                if (feedbackSection.title === AppConstants.DOC_LEVEL) {
                    //we're intereseted only in comments
                    feedbackSection.some(function(innerFeedbackObj, idx) {
                        if (innerFeedbackObj.CommentId === feedbackObj.CommentId) {
                            feedbackObjRemovalIdx = idx;
                            containsReplies = innerFeedbackObj.Replies &&  innerFeedbackObj.Replies.length;
                            return true;
                        }
                    });
                    if (feedbackObjRemovalIdx !== -1) {
                        if (!containsReplies) {
                            feedbackSection.splice(feedbackObjRemovalIdx, 1);
                        } else {
                            feedbackSection[feedbackObjRemovalIdx].CommentStatus = feedbackTypes.FEEDBACK_TYPE_DELETED;
                        }
                        return true;
                    }
                }
            });
            $scope.applyFeedbackFilters();
            //TODO: Check if the case where all comments for a version is deleted is handled properly
        };

        /**
         * Delete's the comment from the view model and sends a request to the server.
         *
         * @param feedbackObj This can be the top level comment or a child reply comment object
         */
        $scope.deleteComment = function(feedbackObj) {
            var promise = null,
                versionId = feedbackObj.VersionId;
            //Deselect the feedback because the annotations move up
            $scope.deselectFeedback();
            if (feedbackObj.CommentStatus === feedbackTypes.FEEDBACK_TYPE_FAILED || feedbackObj.CommentStatus === feedbackTypes.FEEDBACK_TYPE_RETRY) {
                // Remove any records from localStorage
                FeedbackLocalStorageService.deleteCommentIfExists(feedbackObj.CommentId);
                promise = $q.when(true);
            } else if (DocumentService.isGeneratedDraftFeedbackId(feedbackObj.CommentId)) {
                //If the comment was just added and before the success response comes back the user tries to delete it.
                FeedbackService.markCommentToBeDeleted(feedbackObj.CommentId);
                promise = $q.when(true);
            } else {
                promise = FeedbackService.deleteDocumentComment($scope.metadata.Id, versionId, feedbackObj.CommentId);
            }

            var user = authenticatedUser.getUserInfo();
            // ensure the user exists in the map and the count is greater than 0
            if ($scope.documentState.userToFeedbackCountMap[user.Id] &&
                $scope.documentState.userToFeedbackCountMap[user.Id] > 0) {
                $scope.documentState.userToFeedbackCountMap[user.Id] -= 1;
            }

            return promise.then($scope.removeCommentFromViewModel.bind($scope, feedbackObj), function() {
                MessageManager.addTransientErrorMessage(MessageProvider.documentDeleteCommentFail);
                FeedbackService.markCommentToBeDeleted(feedbackObj.CommentId);
            });
        };

        $scope.deleteReplyAnnotation = function(feedbackObj, replyObj) {
            if (!feedbackObj || !replyObj) {
                return;
            }

            $scope.deleteAnnotation(replyObj).then(function() {
                // remove from view
                feedbackObj.Replies = feedbackObj.Replies.filter(function(replyObj2) {
                    return replyObj2.AnnotationId !== replyObj.AnnotationId;
                });
                if (feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DELETED && feedbackObj.Replies && feedbackObj.Replies.length === 0) {
                    // //If a current reply is being deleted and there are no more replies in the parent (which is also deleted)
                    $scope.removeAnnotationFromViewModel(feedbackObj);
                }
            });            
        };

        $scope.deleteReplyComment = function(feedbackObj, replyObj) {
            if (!feedbackObj || !replyObj) {
                return;
            }
            $scope.deleteComment(replyObj).then(function() {
                feedbackObj.Replies = feedbackObj.Replies.filter(function(replyObj2) {
                    return replyObj2.CommentId !== replyObj.CommentId;
                });
                if (feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DELETED && feedbackObj.Replies && feedbackObj.Replies.length === 0) {
                    // //If a current reply is being deleted and there are no more replies in the parent (which is also deleted)
                    $scope.removeCommentFromViewModel(feedbackObj);
                }
            });
        };

        $scope.removeAnnotationFromViewModel = function(feedbackObj) {
            var versionId = feedbackObj.VersionId;
            var feedbackSections = $scope.documentState.feedbackListMap[versionId];
            if (!feedbackSections) {
                return;
            }
            feedbackSections.some(function(feedbackSection){
                var invalidFeedbackObjIdx = -1,
                    containsReplies = false;
                if (feedbackSection.title !== AppConstants.DOC_LEVEL) {
                    feedbackSection.some(function(feedbackObject, idx) {
                        if (feedbackObject.AnnotationId === feedbackObj.AnnotationId) {
                            invalidFeedbackObjIdx = idx;
                            containsReplies = feedbackObject.Replies &&  feedbackObject.Replies.length;
                            return true;
                        }
                    });
                    if (invalidFeedbackObjIdx !== -1) {
                        if (containsReplies) {
                            feedbackSection[invalidFeedbackObjIdx].AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_DELETED;
                        } else {
                            feedbackSection.splice(invalidFeedbackObjIdx, 1);
                        }
                        return true;
                    }
                }
            });
            $scope.documentState.feedbackListMap[versionId] = feedbackSections.filter(function(feedbackSection) {
                //This will filter any empty sections
                return feedbackSection.length || feedbackSection.title === AppConstants.DOC_LEVEL;
            });

            //If it's a top level feedback then notify the bridge layer about it.
            if (!feedbackObj.ParentId && (!feedbackObj.Replies || !feedbackObj.Replies.length)) {
                var deletionMap = {};
                deletionMap[feedbackObj.StartPageNumber + 1] = [feedbackObj.AnnotationId];
                $scope.documentState.documentViewerBridge.deleteAnnotations(deletionMap);
            }
            $scope.applyFeedbackFilters();
        };

        /**
         * Deletes a top level or a reply annotation. Calls the FeedbackService for making HTTP
         * DELETE API call.
         *
         * @param feedbackObj This can be top level feedback object or one of its replies
         */
        $scope.deleteAnnotation = function(feedbackObj) {
            var promise = null,
                versionId = feedbackObj.VersionId;

            if (DocumentStateService.feedback.selectedFeedback) {
                $scope.deselectFeedback();
            }
            if (feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_FAILED ||
                feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_RETRY) {
                // Remove any records from localStorage
                FeedbackLocalStorageService.deleteAnnotationIfExists(feedbackObj.AnnotationId);
                promise = $q.when(true);
            } else if (DocumentService.isGeneratedDraftFeedbackId(feedbackObj.AnnotationId)) {
                //If the comment was just added and before the success response comes back the user tries to delete it.
                FeedbackService.markAnnotationToBeDeleted(feedbackObj.AnnotationId);
                promise = $q.when(true);
            } else {
                promise = FeedbackService.deleteDocumentAnnotation($scope.metadata.Id, versionId, feedbackObj.AnnotationId);
            }

            if (feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_FAILED ||
                feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_RETRY ||
                feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                $scope.documentState.pendingFeedbackCountForAllVersions--;
            }

            var user = authenticatedUser.getUserInfo();
            // ensure the user exists in the map and the count is greater than 0
            if ($scope.documentState.userToFeedbackCountMap[user.Id] &&
                $scope.documentState.userToFeedbackCountMap[user.Id] > 0) {
                $scope.documentState.userToFeedbackCountMap[user.Id] -= 1;
            }

            return promise.then($scope.removeAnnotationFromViewModel.bind($scope, feedbackObj), function() {
                // Failed.
                MessageManager.addTransientErrorMessage(MessageProvider.documentDeleteCommentFail);
            });
        };

        $scope.__cleanupAnyAnnotationInputs = function() {

            if ($scope.__lastFeedbackInReplyMode) {
                $scope.__lastFeedbackInReplyMode.inReplyMode = false;
            }
            if ($scope.__lastFeedbackInEditMode) {
                $scope.__lastFeedbackInEditMode.inEditMode = false;
            }

            var feedbackSections = $scope.documentState.feedbackListMap[$scope.documentState.activeVersion.VersionId];
            if (!feedbackSections) {
                return;
            }
            feedbackSections.forEach(function(feedbackSection){
                var invalidFeedbackObjIdx;
                feedbackSection.forEach(function(feedbackObject, idx) {
                    if (feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_INPUT) {
                        invalidFeedbackObjIdx = idx;
                    }
                });
                if (invalidFeedbackObjIdx !== undefined) {
                    feedbackSection.splice(invalidFeedbackObjIdx, 1);
                }
            });

            $scope.documentState.feedbackListMap[$scope.documentState.activeVersion.VersionId] = feedbackSections.filter(function(feedbackSection) {
                //This will filter any empty sections
                return feedbackSection.length || feedbackSection.title === AppConstants.DOC_LEVEL;
            });
        };

        function cleanupInputsAndScheduleLineDrawing(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (newVal) {
                $scope.__cleanupAnyAnnotationInputs();
            }
            $timeout($scope.triggerAnnotationLineRedraw.bind($scope));
        }

        $scope.triggerAnnotationLineRedraw = function() {
            var prevSelectedFeedback;
            if (!DocumentStateService.feedback.selectedFeedback) {
                return;
            }
            prevSelectedFeedback = DocumentStateService.feedback.selectedFeedback;
            //First the selectedFeedback to NULL so that it does not trigger $digest()
            DocumentStateService.feedback.selectedFeedback = null;
            $scope.getAnnotationClientRect(prevSelectedFeedback.AnnotationId, true).then(function(boundingClientRect) {
                DocumentStateService.feedback.selectedFeedback = prevSelectedFeedback;
                documentViewerBridge.annotationSelected(prevSelectedFeedback.StartPageNumber + 1, prevSelectedFeedback, {
                    top: FeedbackService.getArrowTopPosition(boundingClientRect)
                });
            });
        };

        $scope.$watch('rightPanelView.forceShowingOverallComment', cleanupInputsAndScheduleLineDrawing);
        $scope.$watch('showDraftPublishingComponent() && !rightPanelView.forceHidingDraftPublishingComponent', cleanupInputsAndScheduleLineDrawing);
        $scope.$watch('showDraftPublishingComponent() && !rightPanelView.forceHidingDraftPublishingComponent', function(newVal, oldVal) {
            if (newVal === oldVal) {
                return;
            }
            if (newVal) {
                $scope.deselectFeedback();
            }
        });

        $scope.__addDraftAnnotationInput = function(pageNumber, annotationType, regions) {
            $scope.__cleanupAnyAnnotationInputs();

            $scope.rightPanelView.forceShowingOverallComment = false;
            $scope.rightPanelView.forceHidingDraftPublishingComponent = true;

            var feedbackSections = $scope.documentState.feedbackListMap[$scope.documentState.activeVersion.VersionId];
            var currentFeedbackSection;

            var draftFeedbackObj = {
                Text: '',
                color: '#245064',
                isVisible : true,
                VersionId : DocumentStateService.activeVersionId,
                AnnotationStatus: feedbackTypes.FEEDBACK_TYPE_INPUT,
                Contributor: $scope.user,
                AnnotationId: DocumentService.generateDraftFeedbackId(),
                StartPageNumber: pageNumber - 1,
                Regions: regions,
                AnnotationType: annotationType
            };

            var found = feedbackSections.some(function(feedbackSection) {
                if (feedbackSection.marker === pageNumber) {
                    feedbackSection.isVisible = true;
                    feedbackSection.push(draftFeedbackObj);
                    feedbackSection.sort(DocumentUtilities.compareHighlightPosition);
                    return true;
                }
            });
            if (!found) {
                currentFeedbackSection = [];
                currentFeedbackSection.marker = pageNumber;
                currentFeedbackSection.isVisible = true;
                currentFeedbackSection.push(draftFeedbackObj);
                feedbackSections.push(currentFeedbackSection);
            }
            feedbackSections.sort(DocumentUtilities.feedbackSectionComparator);
            $scope.documentState.feedbackInputShown = true;
            DocumentStateService.feedback.selectedFeedback = draftFeedbackObj;
            $timeout(function() {
                ClientMetricsService.stopAndRecordDocumentLatencyEvent({
                    event: MetricEvents.FEEDBACK_PANEL_EVENTS.RENDER_FEEDBACK_INPUT.name,
                    documentId : $scope.documentState.documentId,
                    versionId : DocumentStateService.activeVersion.VersionId,
                    documentType : DocumentStateService.activeVersion.ContentType,
                    numberOfPages : DocumentStateService.numberOfPages
                });
            }, 0, false);
        };

        $scope.$on(SignalProvider.FeedbackInput.Hide, $scope.__cleanupAnyAnnotationInputs);
        $scope.$on(SignalProvider.FeedbackInput.Clear, $scope.__cleanupAnyAnnotationInputs);

        //This will just re-render the lines
        $scope.reselectFeedback = function() {
            if (DocumentStateService.feedback.selectedFeedback) {
                $scope.selectFeedback(DocumentStateService.feedback.selectedFeedback);
            }
        };

        $scope.selectFeedback = function(feedbackObj, triggeredFromViewer) {
            var latencyHandle = ClientMetricsService.startNewLatencyEvent({
                event: MetricEvents.FEEDBACK_PANEL_EVENTS.RENDER_FEEDBACK_ARROW,
                documentId: $scope.metadata.Id,
                versionId: $scope.metadata.VersionMetadata.VersionId
            });
            
            var mwsMetric = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();
            
            $scope.__cleanupAnyAnnotationInputs();
            var AnnotationId = feedbackObj.AnnotationId,
                pageNumber = feedbackObj.StartPageNumber + 1;

            //First the selectedFeedback to NULL so that it does not trigger $digest()
            DocumentStateService.feedback.selectedFeedback = null;

            //Sometimes the selection of a feedback element causes unwanted scrolling on the feedback panel
            $scope.documentState.ignoreFeedbackScrolling = true;

            $scope.getAnnotationClientRect(AnnotationId, true).then(function(boundingClientRect) {
                DocumentStateService.feedback.selectedFeedback = feedbackObj;
                documentViewerBridge.annotationSelected(pageNumber, feedbackObj, {
                    top: FeedbackService.getArrowTopPosition(boundingClientRect)
                });

                setTimeout(function() {
                    //Continue watching scrolling on the feedback panel
                    $scope.documentState.ignoreFeedbackScrolling = false;
                    latencyHandle.stopAndRecordLatency();
                    mwsMetric.emitMetricWithMethodName('DocumentViewer.RenderArrowForFeedbackSelection');
                    if (triggeredFromViewer) {
                        mwsMetric.emitMetricWithMethodName('DocumentViewer.RenderArrowForFeedbackSelectionInPage');
                    } else {
                        mwsMetric.emitMetricWithMethodName('DocumentViewer.RenderArrowForFeedbackSelectionInFeedbackPanel');
                    }
                });
            });
        };

        /**
         * Selects the feedback in the right panel and downloads the version if required.
         * Only top level feedback objects should be passed in.
         */
        $scope.selectFeedbackAndVersion = function(feedbackObj, docVersionId) {
            if (!feedbackObj || !docVersionId) {
                return;
            }
            if (docVersionId !== DocumentStateService.activeVersionId) {
                $scope.setActiveVersionById(docVersionId).then(function() {
                    //Sometimes the selection of a feedback element causes unwanted scrolling on the feedback panel (due to DOM changes)
                    $scope.documentState.ignoreFeedbackScrolling = true;
                    DocumentStateService.feedback.selectedFeedback = feedbackObj;
                    $timeout(function() {
                        //Continue watching scrolling on the feedback panel
                        $scope.documentState.ignoreFeedbackScrolling = false;
                    }, 0, false);
                });

            } else if (docVersionId === DocumentStateService.activeVersionId) {
                if (DocumentStateService.feedback.selectedFeedback !== feedbackObj) {
                    $scope.selectFeedback(feedbackObj);
                } else {
                    //deselect the feedback
                    $scope.deselectFeedback();
                }
            }
        };

        $scope.newAnnotationSubmit = function(commentText, extraData) {
            var feedbackObject = extraData.feedbackObject;
            $scope.__cleanupAnyAnnotationInputs();
            if (!commentText || !feedbackObject ||
                feedbackObject.AnnotationStatus !== feedbackTypes.FEEDBACK_TYPE_INPUT ||
                !$scope.documentState.pendingAnnotation) {
                return;
            }

            var user = authenticatedUser.getUserInfo();
            var draftAnnotation = {
                isVisible: true,
                Text: commentText,
                MarkupText : '',
                //For top level annotations, ThreadId is the same as AnnotationId
                ThreadId : feedbackObject.AnnotationId,
                color : AppConstants.DRAFT_COLOR,
                Visibility: extraData.isPrivate ? FEEDBACK_VISIBILITY.PRIVATE : FEEDBACK_VISIBILITY.PUBLIC,
                DocumentId : $scope.metadata.Id,
                VersionId : DocumentStateService.activeVersionId,
                AnnotationStatus: feedbackTypes.FEEDBACK_TYPE_DRAFT,
                Contributor: user ? user : $scope.user,
                AnnotationId: feedbackObject.AnnotationId,
                StartPageNumber: $scope.documentState.pendingAnnotation.pageNumber - 1,
                Regions: $scope.documentState.pendingAnnotation.regions,
                AnnotationType: $scope.documentState.pendingAnnotation.type
            };
            $scope.preprocessFeedbackText(draftAnnotation);

            FeedbackService.postDocumentAnnotation(draftAnnotation).then(function(annotation) {
                //Always keep the ThreadId and the AnnotationId in sync for top level annotations and comments
                draftAnnotation.ThreadId = draftAnnotation.AnnotationId = annotation.AnnotationId;
            }, function() {
                draftAnnotation.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_FAILED;
            });
            $scope.addUserToFeedbackUserMap(draftAnnotation.Contributor);

            // ensure the user exists in the map
            if (!$scope.documentState.userToFeedbackCountMap[user.Id]) {
                $scope.documentState.userToFeedbackCountMap[user.Id] = 0;
            }
            $scope.documentState.userToFeedbackCountMap[user.Id] += 1;
            $scope.documentState.pendingFeedbackCountForAllVersions++;
            $scope.documentState.documentVersionCommentsMap[draftAnnotation.VersionId] += 1;

            /* ********************** */
            var pageNum,
                feedbackSection;

            pageNum = $scope.documentState.pendingAnnotation.pageNumber;

            // fix the filter issue caused by angular version 1.3.14
            angular.forEach($scope.documentState.feedbackListMap[DocumentStateService.activeVersionId], function(feedbackSectionParam) {
                if (feedbackSectionParam.marker === parseInt(pageNum, 10)) {
                    feedbackSection = feedbackSectionParam;
                }
            });

            if (feedbackSection) {
                feedbackSection.push(draftAnnotation);
                feedbackSection.sort(DocumentUtilities.compareHighlightPosition);
            } else {
                feedbackSection = [];
                feedbackSection.title = 'Page ' + parseInt(pageNum, 10);
                feedbackSection.isVisible = true;
                feedbackSection.marker = parseInt(pageNum, 10);
                feedbackSection.push(draftAnnotation);
                if (!$scope.documentState.feedbackListMap[DocumentStateService.activeVersionId]) {
                    $scope.documentState.feedbackListMap[DocumentStateService.activeVersionId] = [];
                }
                $scope.documentState.feedbackListMap[DocumentStateService.activeVersionId].push(feedbackSection);
                $scope.documentState.feedbackListMap[DocumentStateService.activeVersionId].sort(function (feedbackSectionA, feedbackSectionB) {
                    return feedbackSectionA.marker - feedbackSectionB.marker;
                });
            }
            documentViewerBridge.annotationCreated(pageNum, draftAnnotation);
            $timeout(function() {
                $scope.selectFeedback(draftAnnotation);
            });
        };

        $scope.newAnnotationCancel = function(feedbackObject, feedbackText) {
            $scope.__cleanupAnyAnnotationInputs();
            $scope.deselectFeedback();
            documentViewerBridge.newAnnotationCanceled();
        };

        $scope.updateAnnotation = function(feedbackText, extraData) {
            var feedbackObject = extraData.feedbackObject;

            if (!feedbackText || !(feedbackText.trim())) {
                $timeout(function() {
                    if (extraData.parentFeedbackObject) {
                        $scope.deleteReplyAnnotation(extraData.parentFeedbackObject, feedbackObject);
                    } else {
                        $scope.deleteAnnotation(feedbackObject);
                    }
                });
                feedbackObject.inEditMode = false;
                return;
            }

            ClientMetricsService.addJsOperationToSession('Annotation_Added', true);

            // Update an Annotation
            feedbackObject.Visibility = extraData.isPrivate ? FEEDBACK_VISIBILITY.PRIVATE : FEEDBACK_VISIBILITY.PUBLIC;
            feedbackObject.Text = feedbackText;
            $scope.preprocessFeedbackText(feedbackObject);

            FeedbackService.updateDocumentAnnotation(feedbackObject)
            .then(function(response) {
                var data = response.data;
                if (!data.Annotation) {
                    return;
                }
                feedbackObject.Text = feedbackText;
                $scope.preprocessFeedbackText(feedbackObject);

                feedbackObject.Visibility = data.Annotation.Visibility;
                // SUCCESS, nothing stopped us from getting here...
                MessageManager.clearTransientMessages();
            }, function(response) {
                // FAILURE: An error occured
                MessageManager.addTransientErrorMessage(MessageProvider.documentUpdateCommentFail);
                DocumentStateService.isCreatingFeedback = false;
                $scope.clearFeedback(feedbackObject);
            }).finally(function() {
                feedbackObject.inEditMode = false;
            });
        };

        /**
         * This method finds the parent feedback object according to the ThreadId of the passed
         * feedbackObject.
         *
         * If it cannot find out it returns NULL
         */
        $scope.__getFeedbackObjectForThread = function(feedbackObject) {
            var isAnnotation = DocumentUtilities.isAnnotation(feedbackObject),
                isComment = DocumentUtilities.isComment(feedbackObject),
                resultFeedbackObj = null;
            if ( isAnnotation && feedbackObject.ThreadId === feedbackObject.AnnotationId) {
                return feedbackObject;
            }
            if ( isComment && feedbackObject.ThreadId === feedbackObject.CommentId) {
                return feedbackObject;
            }
            angular.forEach($scope.documentState.feedbackListMap, function(feedbackSections) {
                if (resultFeedbackObj) {
                    return;
                }
                feedbackSections.some(function(feedbackSection) {
                    if (isComment && feedbackSection.title === AppConstants.DOC_LEVEL) {
                        return feedbackSection.some(function(feedbackObjInner) {
                            if (feedbackObjInner.CommentId === feedbackObject.ThreadId) {
                                resultFeedbackObj = feedbackObjInner;
                                return true;
                            }
                        });
                    } else if (isAnnotation && feedbackSection.title !== AppConstants.DOC_LEVEL) {
                        return feedbackSection.some(function(feedbackObjInner) {
                            if (feedbackObjInner.AnnotationId === feedbackObject.ThreadId) {
                                resultFeedbackObj = feedbackObjInner;
                                return true;
                            }
                        });
                    }
                });
            });
            return resultFeedbackObj;
        };

        $scope.__saveAnnotationReply = function(commentText, parentFeedbackObj, extraData) {
            if (!commentText || (parentFeedbackObj && !parentFeedbackObj.AnnotationId)) {
                return;
            }
            var threadFeedbackObj;
            var user = authenticatedUser.getUserInfo();
            var draftAnnotation = {
                isVisible : true,
                DocumentId : $scope.metadata.Id,
                VersionId : parentFeedbackObj.VersionId,
                Text: commentText,
                Visibility: extraData.isPrivate ? FEEDBACK_VISIBILITY.PRIVATE : FEEDBACK_VISIBILITY.PUBLIC,
                MarkupText: '',
                comment : commentText,
                AnnotationStatus: feedbackTypes.FEEDBACK_TYPE_DRAFT,
                Contributor: user ? user : $scope.user,
                AnnotationId: DocumentService.generateDraftFeedbackId()
            };
            $scope.preprocessFeedbackText(draftAnnotation);

            // ensure the user exists in the map
            if (!$scope.documentState.userToFeedbackCountMap[user.Id]) {
                $scope.documentState.userToFeedbackCountMap[user.Id] = 0;
            }
            $scope.documentState.userToFeedbackCountMap[user.Id] += 1;
            $scope.documentState.pendingFeedbackCountForAllVersions++;

            if (parentFeedbackObj) {
                draftAnnotation.ParentId = parentFeedbackObj.AnnotationId;
                draftAnnotation.ParentFeedback = parentFeedbackObj;
                if (!parentFeedbackObj.ParentId) {
                    //Top level feedback's reply
                    threadFeedbackObj  = parentFeedbackObj;
                } else {
                    //2nd level feedback's reply
                    threadFeedbackObj  = $scope.__getFeedbackObjectForThread(parentFeedbackObj);
                }
                if (threadFeedbackObj !== null) {
                    draftAnnotation.ThreadId = parentFeedbackObj.ThreadId;
                    threadFeedbackObj.Replies = threadFeedbackObj.Replies ? threadFeedbackObj.Replies : [];
                    threadFeedbackObj.Replies.push(draftAnnotation);
                }
            }
            FeedbackService.postDocumentAnnotation(draftAnnotation).then(function(annotation) {
                draftAnnotation.AnnotationId = annotation.AnnotationId;
            }, function() {
                draftAnnotation.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_FAILED;
            });
            $scope.addUserToFeedbackUserMap(draftAnnotation.Contributor);
        };

        /**
         * Entry method from the Feedback Input Component to save the user entered annotation
         *
         * @feedbackText The text entered by the user
         */
        $scope.submitAnnotationReply = function(feedbackText, extraData) {
            var feedbackObj = extraData.feedbackObject;
            if (feedbackObj) {
                $scope.__saveAnnotationReply(feedbackText, feedbackObj, extraData);
            }
            if (feedbackObj) {
                feedbackObj.inReplyMode = false;
            }
        };

        $scope.showVersionComments = function(version) {

            if ($scope.documentState.selectedPerson === null) {
                var feedbackSections = $scope.documentState.feedbackListMap[version.VersionId] || [];
                return !!feedbackSections.filter($scope.canDisplayFeedbackSection.bind($scope, version.VersionId)).length;
            } else {
                var versionFeedback = $scope.documentState.feedbackListMap[version.VersionId] || [];
                versionFeedback = versionFeedback.filter($scope.canDisplayFeedbackSection.bind($scope, version.VersionId));
                if (versionFeedback) {
                    for (var i = 0; i < versionFeedback.length; i++) {
                        for (var j = 0; j < versionFeedback[i].length; j++) {
                            if (versionFeedback[i][j].Contributor.Id == $scope.documentState.selectedPerson.Id) {
                                return true;
                            }
                            if (versionFeedback[i][j].Replies) {
                                for (var k = 0; k < versionFeedback[i][j].Replies.length; k++) {
                                    if (versionFeedback[i][j].Replies[k].Contributor.Id == $scope.documentState.selectedPerson.Id) {
                                        return true;
                                    }
                                }
                            }
                        }
                    }
                }
                return false;
            }
        };

        $scope.publishDraftAnnotations = function(feedbackText, extraData) {
            var notifyContribs = extraData.notifyCollaborators;
            var metricsOperation = MetricEvents.FEEDBACK + MetricEvents.ACTIONS.SAVE;

            //Publish draft annotations for all versions and associate any text entered as
            //the overall comment for the current version
            var versionsWithDrafts = [];
            angular.forEach($scope.documentState.feedbackListMap, function(feedbackSections, versionId) {
                if (!feedbackSections || !versionId) {
                    return;
                }
                feedbackSections.forEach(function(feedbackSection){
                    feedbackSection.forEach(function(feedbackObject) {
                        if (feedbackObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                            versionsWithDrafts.push(versionId);
                        } else if (feedbackObject.Replies && feedbackObject.Replies.length) {
                            feedbackObject.Replies.forEach(function(replyObject) {
                                if (replyObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                    versionsWithDrafts.push(versionId);
                                }
                            });
                        }
                    });
                });
            });
            versionsWithDrafts = _.uniq(versionsWithDrafts);
            if (versionsWithDrafts.length) {
                var oldDraftCount = $scope.documentState.pendingFeedbackCountForAllVersions;
                $scope.documentState.pendingFeedbackCountForAllVersions = 0;
                //Make the count immediately zero, so that the Publish draft annotations component goes away
                FeedbackService.publishDraftAnnotationsForVersions($scope.metadata.Id, versionsWithDrafts, notifyContribs)
                .then(function() {
                    var updatedAnnotationIds = {};
                    //Update the feedbackObj status after publishing it instead of calling downloadFeedback for each version
                    angular.forEach($scope.documentState.feedbackListMap, function(feedbackSections, versionId) {
                        feedbackSections.forEach(function(feedbackSection){
                            feedbackSection.forEach(function(feedbackObj) {
                                if (feedbackObj.AnnotationStatus) {
                                    if (feedbackObj.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                        // A draft cannot have Replies property, so don't bother checking Replies

                                        // TODO(vivitsum) - If annotation does not exist on service as a draft, it should not be
                                        // set to published. This will cause all kinds of problems. The right approach is to
                                        // try to save it on the service as draft, and then publish it. For that we need to know
                                        // if it has a service generated Annotation ID

                                        feedbackObj.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
                                        if (DocumentStateService.feedback.users[feedbackObj.Contributor.Id]) {
                                            feedbackObj.color  = DocumentStateService.feedback.users[feedbackObj.Contributor.Id].color;
                                        } else {
                                            feedbackObj.color  = AppConstants.DRAFT_COLOR;
                                        }
                                        if (versionId === DocumentStateService.activeVersionId) {
                                            updatedAnnotationIds[feedbackObj.StartPageNumber + 1] = updatedAnnotationIds[feedbackObj.StartPageNumber + 1] ?
                                                updatedAnnotationIds[feedbackObj.StartPageNumber + 1] :
                                                (updatedAnnotationIds[feedbackObj.StartPageNumber + 1] = []);
                                            updatedAnnotationIds[feedbackObj.StartPageNumber + 1].push({
                                                AnnotationId : feedbackObj.AnnotationId,
                                                AnnotationStatus : feedbackTypes.FEEDBACK_TYPE_PUBLISHED,
                                                color :  feedbackObj.color
                                            });
                                        }
                                        feedbackObj.Created = new Date();
                                        feedbackObj.doSlide = -1;
                                    } else if (feedbackObj.Replies && feedbackObj.Replies.length) {
                                        feedbackObj.Replies.forEach(function(replyObject) {
                                            if (replyObject.AnnotationStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                                replyObject.AnnotationStatus = feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
                                                if (DocumentStateService.feedback.users[replyObject.Contributor.Id]) {
                                                    replyObject.color  = DocumentStateService.feedback.users[replyObject.Contributor.Id].color;
                                                } else {
                                                    replyObject.color  = AppConstants.DRAFT_COLOR;
                                                }

                                                replyObject.Created = new Date();
                                            }
                                        });
                                    }
                                } else if (feedbackObj.CommentId && !feedbackObj.CommentStatus) {
                                    if (feedbackObj.CommentStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                        feedbackObj.CommentStatus = feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
                                        feedbackObj.Created = new Date();
                                        feedbackObj.doSlide = -1;
                                    }  else if (feedbackObj.Replies && feedbackObj.Replies.length) {
                                        feedbackObj.Replies.forEach(function(replyObject) {
                                            if (replyObject.CommentStatus === feedbackTypes.FEEDBACK_TYPE_DRAFT) {
                                                replyObject.CommentStatus = feedbackTypes.FEEDBACK_TYPE_PUBLISHED;
                                                replyObject.Created = new Date();
                                            }
                                        });
                                    }
                                }
                            });
                        });
                    });


                    documentViewerBridge.receiveAnnotationUpdates(updatedAnnotationIds);

                    // Refresh document activity feed
                    ClientMetricsService.addJsOperationToSession(metricsOperation, true);
                }, function(response, status, headers, config) {
                    $scope.documentState.pendingFeedbackCountForAllVersions = oldDraftCount;
                    var data = response.data;
                    if (DocumentStateService.retry) {
                        DocumentStateService.retry = false;
                    }
                    if (data) {
                        ClientMetricsService.addJsOperationToSession(metricsOperation, false, data.Message);
                    }
                });
            }
            if (!feedbackText.trim()) {
                return;
            }
            $scope.deselectFeedback();
            var latestVersionId = DocumentUtilities.getLatestNonDraftVersionId($scope.documentState.documentVersions);

            var newFeedbackObj = {
                DocumentId : $scope.metadata.Id,
                VersionId : latestVersionId
            };
            $scope.__publishOverallComment(newFeedbackObj, feedbackText, notifyContribs, extraData.isPrivate).then($scope.__scrollCommentIntoView.bind($scope));
        };

        $scope.__publishOverallComment = function(feedbackObj, commentText, notifyContribs, isPrivate) {
            if (!commentText) {
                return;
            }
            var metricsOperation = MetricEvents.FEEDBACK + MetricEvents.ACTIONS.PUBLISH;
            var user = authenticatedUser.getUserInfo();
            var commentObjOuter = {
                DocumentId : $scope.metadata.Id,
                VersionId : feedbackObj.VersionId,
                Text : commentText,
                Visibility : isPrivate ? FEEDBACK_VISIBILITY.PRIVATE : FEEDBACK_VISIBILITY.PUBLIC,
                MarkupText : '',
                CommentStatus: feedbackTypes.FEEDBACK_TYPE_DRAFT,
                Contributor: user,
                NotifyCollaborators: notifyContribs,
                CommentId: DocumentService.generateDraftFeedbackId()
            };
            $scope.preprocessFeedbackText(commentObjOuter);
            if (feedbackObj.CommentId) {
                commentObjOuter.ParentId = feedbackObj.CommentId;
            }
            return FeedbackService.postDocumentComment(commentObjOuter).then(function(Comment) {
                    addCommentToViewModel(Comment, true);
                    return Comment;
                }, function(response) {
                    var err = response.data;
                    if (err && err.Message && (err.Message.indexOf(DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION2) === 0 || err.Message.indexOf(DOCUMENT_LOCKED_FOR_COMMENTS_EXCEPTION1) === 0)) {
                        $scope.documentFormData.disableFeedback = true;
                        MessageManager.addTransientErrorMessage(MessageProvider.documentFeedbackDisabled);
                    } else {
                        addCommentToViewModel(commentObjOuter, false);
                    }
                    if (err) {
                        ClientMetricsService.addJsOperationToSession(metricsOperation, false, err.Message);
                    }
                    return commentObjOuter;
                }).finally(function() {
                    feedbackObj.inReplyMode = false;
                });

            function addCommentToViewModel(comment, isSuccessful) {
                var threadFeedbackObj;
                var user = authenticatedUser.getUserInfo();
                var feedbackSection;
                var feedbackSections;
                var commentObj = angular.extend({}, commentObjOuter, {
                    CommentId: comment.CommentId,
                    InitiallyHidden: true,
                    Created : new Date(),
                    CommentStatus : isSuccessful ? feedbackTypes.FEEDBACK_TYPE_PUBLISHED : feedbackTypes.FEEDBACK_TYPE_FAILED,
                    Text: comment.Text,
                    isVisible: true,
                    MarkupText : ''
                });
                $scope.preprocessFeedbackText(commentObj);
                if (feedbackObj.CommentId) {
                    commentObj.ParentId = feedbackObj.CommentId;
                    commentObj.ParentFeedback = feedbackObj;
                    if (!feedbackObj.ParentId) {
                        threadFeedbackObj  = feedbackObj;
                    } else {
                        threadFeedbackObj  = $scope.__getFeedbackObjectForThread(feedbackObj);
                    }
                    if (threadFeedbackObj !== null) {
                        commentObj.ThreadId = threadFeedbackObj.CommentId;
                        threadFeedbackObj.Replies = threadFeedbackObj.Replies ? threadFeedbackObj.Replies : [];
                        threadFeedbackObj.Replies.push(commentObj);
                        threadFeedbackObj.Replies.sort(DocumentUtilities.feedbackRepliesComparator);
                    }
                } else {
                    $scope.documentState.feedbackListMap[feedbackObj.VersionId].some(function(feedbackSectionObj) {
                        if (feedbackSectionObj.title === AppConstants.DOC_LEVEL) {
                            feedbackSection = feedbackSectionObj;
                            return true;
                        }
                    });
                    if (feedbackSection) {
                        //Here we should append to the list and not the start of the list
                        feedbackSection.push(commentObj);
                    } else {
                        feedbackSection = [];
                        feedbackSection.isVisible = true;
                        feedbackSection.title = AppConstants.DOC_LEVEL;
                        feedbackSection.marker = 0;
                        feedbackSection.unshift(commentObj);
                        feedbackSections = $scope.documentState.feedbackListMap[feedbackObj.VersionId];
                        if (!feedbackSections) {
                            feedbackSections = $scope.documentState.feedbackListMap[feedbackObj.VersionId] = [];
                        }
                        feedbackSections.unshift(feedbackSection);
                    }
                }

                // ensure the user exists in the map
                if (!$scope.documentState.userToFeedbackCountMap[user.Id]) {
                    $scope.documentState.userToFeedbackCountMap[user.Id] = 0;
                }
                $scope.documentState.userToFeedbackCountMap[user.Id] += 1;
                $scope.documentState.documentVersionCommentsMap[feedbackObj.VersionId] += 1;
                ClientMetricsService.recordCounterEvent(MetricEvents.PUBLISH_COMMENT_COUNTER, 1);
                ClientMetricsService.addJsOperationToSession(metricsOperation, true);
                return commentObj;
            }
        };

    }
}(angular, _));
